/* eslint-disable */
import XLSX from 'xlsx';

const excel = {
  sheet2blob(data, sheetName, options = {}) {
    var sheets = [];
    for (let i = 0; i < data.length; i += 1) {
      sheets.push(XLSX.utils.aoa_to_sheet(data[i]));
    }
    var workbook = {
      SheetNames: sheetName,
      Sheets: {}
    };
    for (let i = 0; i < sheetName.length; i++) {
      if (options.cols) {
        sheets[i]['!cols'] = options.cols;
      }
      
      if (options.rows) {
        sheets[i]['!rows'] = options.rows;
      }

      workbook.Sheets[sheetName[i]] = sheets[i];
    }

    // 生成excel的配置项
    var wopts = {
      bookType: 'xlsx', // 要生成的文件类型
      bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
      type: 'binary'
    };
    var wbout = XLSX.write(workbook, wopts);
    var blob = new Blob([s2ab(wbout)], {type:"application/octet-stream"});
    // 字符串转ArrayBuffer
    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    return blob;
  },
  openDownloadDialog(data, dataName, saveName, options) {
    var url = this.sheet2blob(data, dataName, options);
    if(typeof url == 'object' && url instanceof Blob)
    {
      url = URL.createObjectURL(url); // 创建blob地址
    }
    var aLink = document.createElement('a');
    aLink.href = url;
    aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
    var event;
    if(window.MouseEvent) event = new MouseEvent('click');
    else
    {
      event = document.createEvent('MouseEvents');
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    }
    aLink.dispatchEvent(event);
  },
};

export default excel;